<template>
  <v-app>
    <v-content>
      <loader
        v-show="loader"
        object="#29B3A6"
        color1="#29B3A6"
        color2="#17fd3d"
        size="4"
        speed="2"
        bg="#343a40"
        objectbg="#999793"
        opacity="80"
        name="spinning"
      ></loader>
      <Blank />
    </v-content>
  </v-app>
</template>

<script>
import $ from "jquery";
export default {
  name: "App",
  components: {},
  watch: {
    $route() {
      let vueBox = this;
      vueBox.loader = true;
      $(".container-scroller").scroll(0, 0);
      setTimeout(function () {
        vueBox.loader = false;
      }, 200);
    },
  },
  data() {
    return {
      loader: true,
    };
  },
  mounted() {
    this.loader = false;
  },
  created() {
    $(".container-scroller").scroll(0, 0);
  },
};
</script>

<style>
.v-input .v-label {
  line-height: 20px !important;
}
.v-overflow-btn .v-select__slot .v-label {
  height: 30px !important;
  line-height: 40px !important;
}
.swal2-container {
  z-index: 999999999 !important;
}
.connect-btn {
  color: #2f5e59 !important;
}
.error-box {
  color: darkred;
}
.vs__dropdown-toggle {
  background: #fff;
  height: 40px;
  border: 1px solid #29b3a6;
}
body {
  font-size: 14px !important;
}
h3,
.h3 {
  font-size: 1.13rem !important;
}
#menuNav {
  overflow: scroll !important;
  -ms-overflow-style: none !important; /* IE and Edge */
  scrollbar-width: none !important;
  height: 60vh;
}
#menuNav::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.theme--light.v-toolbar.v-sheet {
  background: #f8f8f8 !important;
}
.v-card.v-sheet.theme--light {
  background: #f8f8f8 !important;
}
.container-scroller {
  overflow-x: hidden;
}
.api .v-text-field__details {
  display: none !important;
}

.home-top-card {
  border-bottom: 3px solid #29b3a6;
}

.loader_panel_component {
  margin-top: 15%;
}
.loader_panel_component img {
  width: 150px;
}
.loader_panel_component span {
  margin-top: 10px;
  font-weight: 500;
  font-size: 14pt;
}
.background-linear {
  background-image: linear-gradient(#f8f8f8, #29b3a6) !important;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  white-space: nowrap;
}
td {
  white-space: nowrap;
}
.v-chip.v-size--default {
  height: 23px !important;
}
.theme--light.v-input input {
  background: transparent;
}
#app {
  background: transparent;
}
.navbar {
  background: transparent;
  height: 0;
}
@media (max-width: 991px) {
  .navbar {
    right: 0;
  }
}
.navbar .navbar-menu-wrapper {
  width: 100%;
  padding: 0;
}
.v-application {
  font-family: "Nunito", sans-serif !important;
}

.btn-primary {
  background: #29b3a6;
  border: 1px solid #29b3a6;
}
.btn-primary:hover,
.btn-primary:active {
  background: #29b3a6;
  border: 1px solid #29b3a6;
}
*:focus {
  outline: none;
}
.enter-btn {
  width: 100%;
  border-radius: 6px;
  padding: 10px 25px;
  color: rgba(41, 179, 166, 1);
  background: #f8f8f8;
  cursor: pointer;
  border: 1px solid rgba(41, 179, 166, 1);
}
.enter-btn:hover,
.enter-btn:active,
.enter-btn:focus {
  color: #fff;
  background: rgb(148, 226, 217);
  border: 1px solid rgba(41, 179, 166, 1);
}

.v-application .primary {
  background: #29b3a6;
}
.v-application .elevation-7,
.v-application .elevation-1 {
  box-shadow: none !important;
}
.v-sheet.v-card:not(.v-sheet--outlined),
.v-sheet.v-toolbar:not(.v-sheet--outlined),
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
}
.theme--light.v-overflow-btn.theme--light.v-overflow-btn
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #f8f8f8;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined),
.theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  box-shadow: none !important;
  /* border-radius: 50px;*/
  background: #29b3a6;
  color: #ffffff;
  margin-bottom: 30px;
}
.v-card__title {
  /*  text-transform: uppercase; */
  font-weight: bold;
}
.v-data-table__wrapper tr {
  border-top: 10px solid #f8f8f8 !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.v-data-table__wrapper tbody {
  border-bottom: 10px solid #f8f8f8 !important;
}
.v-data-table-header,
.background-tb {
  background: #29b3a6 !important;
  color: #fff !important;
}
.background-tb {
  margin-bottom: 0 !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #ddd;
}
.v-application .headline {
  font-weight: bold;
  font-family: "Nunito", sans-serif !important;
}
.v-application .float-right {
  font-size: 10pt !important;
}
.sidebar-dark .sidebar .nav .nav-item.active > .nav-link {
  background: #29b3a6;
}
.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 0;
}
.v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  top: 5px;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #fff;
  font-family: "Nunito", sans-serif;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  color: #fff !important;
}
.v-tabs-items {
  padding: 0 !important;
}
.v-sheet.v-toolbar:not(.v-sheet--outlined),
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border-radius: 6px;
}
.v-card > *:last-child:not(.v-btn):not(.v-chip) {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.user_name {
  font-size: 13pt;
  font-weight: 600;
}
.v-toolbar__content {
  height: 90px !important;
}
.v-tab--active {
  background: rgb(41, 179, 166);
  color: #fff !important;
}
.v-tab {
  border-radius: 0 !important;
}
.theme--light.v-tabs > .v-tabs-bar {
  border-bottom: 5px solid #f8f8f8;
}
.img-profil {
  width: 50px;
  height: 50px;
}
.language-text {
  display: inline-block;
}
@media (max-width: 991px) {
  #beginContent {
    margin-top: 40px !important;
  }
  .language-text {
    display: none;
  }
  .v-tab {
    font-size: 7pt;
  }
  .user_name {
    font-size: 9pt;
    font-weight: 500;
  }
  .navbarToSidebar {
    background: #fff;
  }
  .navbar {
    background: #fff;
    position: absolute;
    right: 10px;
  }
  .content-wrapper {
    padding-top: 0;
  }
}
.v-toolbar__content .v-btn--contained {
  margin-bottom: 40px !important;
  /*border-radius: 50px !important;*/
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(55, 55, 55, 0.8) !important;
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0.2) !important;
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0) !important;
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(55, 55, 55, 0.8) !important;
    box-shadow: 0 0 0 0 rgba(55, 55, 55, 0.8) !important;
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(55, 55, 55, 0.4) !important;
    box-shadow: 0 0 0 10px rgba(55, 55, 55, 0.4) !important;
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0) !important;
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0) !important;
  }
}

.pulse {
  animation: pulse 1s infinite !important;
}
.home_top_number {
  font-weight: 500 !important;
}

.authors-container .author {
  float: left;
  position: relative;
  transition: opacity 0.25s;
  -webkit-transition: opacity 0.25s;
  z-index: 3;
}

.authors-container .author:nth-child(1) {
  z-index: 100;
}

.authors-container .author:nth-child(2) {
  z-index: 99;
  margin-left: -20px;
}

.authors-container .author:nth-child(3) {
  z-index: 98;
  margin-left: -20px;
}

.authors-container .author:nth-child(4) {
  z-index: 97;
  margin-left: -20px;
}

.authors-container .author:nth-child(5) {
  z-index: 96;
  margin-left: -20px;
}

.authors-container .author:nth-child(6) {
  z-index: 95;
  margin-left: -20px;
}

.authors-container .author:nth-child(7) {
  z-index: 94;
  margin-left: -20px;
}

.authors-container .author:nth-child(8) {
  z-index: 93;
  margin-left: -20px;
}

.authors-container .author:nth-child(9) {
  z-index: 92;
  margin-left: -20px;
}

.authors-container .author:nth-child(10) {
  z-index: 91;
  margin-left: -20px;
}

.authors-container .author:nth-child(11) {
  z-index: 90;
  margin-left: -20px;
}

.authors-container .author {
  float: left;
  position: relative;
  transition: opacity 0.25s;
  -webkit-transition: opacity 0.25s;
  z-index: 3;
}

.authors-container .author:nth-child(1) {
  z-index: 100;
}

.authors-container .author:nth-child(2) {
  z-index: 99;
  margin-left: -20px;
}

.authors-container .author:nth-child(3) {
  z-index: 98;
  margin-left: -20px;
}

.authors-container .author:nth-child(4) {
  z-index: 97;
  margin-left: -20px;
}

.authors-container .author:nth-child(5) {
  z-index: 96;
  margin-left: -20px;
}

.authors-container .author:nth-child(6) {
  z-index: 95;
  margin-left: -20px;
}

.authors-container .author:nth-child(7) {
  z-index: 94;
  margin-left: -20px;
}

.authors-container .author:nth-child(8) {
  z-index: 93;
  margin-left: -20px;
}

.authors-container .author:nth-child(9) {
  z-index: 92;
  margin-left: -20px;
}

.authors-container .author:nth-child(10) {
  z-index: 91;
  margin-left: -20px;
}

.authors-container .author:nth-child(11) {
  z-index: 90;
  margin-left: -20px;
}

.authors-container:hover .author {
  opacity: 0.3;
}

.authors-container .author:hover {
  opacity: 1;
  z-index: 101;
}

.authors-container > .author > .account-photo {
  width: 55px;
  height: 55px;
  border-width: 2px;
}

.authors-container:after {
  clear: both;
  content: " ";
  display: table;
}
.product-page .authors-container {
  margin: 0 auto;
}

.product-page .authors-container > .author > .account-photo {
  width: 70px;
  height: 70px;
  border-width: 3px;
}

.account-photo img {
  width: 100%;
}

.account-photo .mask {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: block;
  border-radius: 50%;
}

.account-photo .account-type {
  position: absolute;
  bottom: -7px;
  color: #ffffff;
  right: -10px;
  width: 30px;
  background-color: #999999;
  height: 30px;
  text-align: center;
  line-height: 26px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  font-size: 13px;
  z-index: 3;
}

.account-photo.account-early-adopter {
  border-color: rgba(41, 179, 166, 0.55);
}

.account-photo.account-admin,
.account-photo.account-product-owner {
  border-color: rgba(41, 179, 166, 0.55);
}

.account-admin .account-type,
.account-product-owner .account-type {
  background-color: #29b3a6;
}

.account-photo {
  position: relative;
  width: 50px;
  height: 50px;
  display: block;
  margin: 0 auto;
  border-radius: 50%;
  border: 3px solid rgba(41, 179, 166, 0.65);
  border-color: #ccc;
}
.account-photo img {
  width: 100%;
  height: 100%;
}

.account-photo .mask {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: block;
  border-radius: 50%;
}

.account-photo .account-type {
  position: absolute;
  bottom: -7px;
  color: #ffffff;
  right: -10px;
  width: 30px;
  background-color: #999999;
  height: 30px;
  text-align: center;
  line-height: 26px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  font-size: 13px;
  z-index: 3;
}

.account-photo.account-early-adopter {
  border-color: rgba(0, 186, 157, 0.55);
}

.account-photo.account-admin,
.account-photo.account-product-owner {
  border-color: rgba(0, 186, 157, 0.55);
}

.account-early-adopter .account-type {
  background-color: #29b3a6;
}

.account-admin .account-type,
.account-product-owner .account-type {
  background-color: #29b3a6;
}

.details_means {
  display: none;
  transition-duration: 0.5s;
  text-align: left;
  position: absolute !important;
  background: #fff !important;
  top: 11px;
  width: 86.22%;
  border: none !important;
}
.means_template {
  cursor: pointer;
}
.means_template:hover .details_means {
  display: block !important;
}
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}
.api .v-input__slot {
  border-radius: 10px !important;
}
.marchandTemplate .v-tabs-bar__content,
.marchandTemplate .v-slide-group__wrapper {
  background: currentColor !important;
}
.v-dialog__content--active,
.v-overlay--active {
  z-index: 999999999999999 !important;
}
.chooseAll {
  background: white !important;
}
.v-tabs-slider-wrapper {
  height: 0 !important;
}
.theme--light.v-overflow-btn.theme--light.v-overflow-btn
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #323030 !important;
}

/* stripe css Variables */
* {
  box-sizing: border-box;
}

/*
    form {
        width: 30vw;
        min-width: 500px;
        align-self: center;
        box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
        0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
        border-radius: 7px;
        padding: 40px;
    }
    input {
        border-radius: 6px;
        margin-bottom: 6px;
        padding: 12px;
        border: 1px solid rgba(50, 50, 93, 0.1);
        height: 44px;
        font-size: 16px;
        width: 100%;
        background: white;
    }
    */
.result-message {
  line-height: 22px;
  font-size: 16px;
}
.result-message a {
  color: rgb(89, 111, 214);
  font-weight: 600;
  text-decoration: none;
}
.hidden {
  display: none;
}
#card-error {
  color: rgb(105, 115, 134);
  text-align: left;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}
#card-element {
  border-radius: 4px 4px 0 0;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  width: 100%;
  background: white;
}
#payment-request-button {
  margin-bottom: 32px;
}
/* Buttons and links */

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}
@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 600px) {
  form {
    width: 80vw;
  }
}
.effect8 {
  position: relative;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 40px rgba(0, 0, 0, 0.1) inset !important;
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 40px rgba(0, 0, 0, 0.1) inset !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset !important;
}
.effect8:before,
.effect8:after {
  content: "";
  position: absolute;
  z-index: -1;
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
  top: 10px;
  bottom: 10px;
  left: 0;
  right: 0;
  -moz-border-radius: 100px / 10px;
  border-radius: 100px / 10px;
}
.effect8:after {
  right: 10px;
  left: auto;
  -webkit-transform: skew(8deg) rotate(3deg);
  -moz-transform: skew(8deg) rotate(3deg);
  -ms-transform: skew(8deg) rotate(3deg);
  -o-transform: skew(8deg) rotate(3deg);
  transform: skew(8deg) rotate(3deg);
}
.navbar {
  height: 4.0625rem;
}
.card {
  border: none;
}
.btn-outline-primary {
  border-color: #29b3a6 !important;
  text-transform: uppercase;
}
.btn-outline-primary:hover {
  background: #29b3a6 !important;
}

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 38px !important;
  border-radius: 10px !important;
}
.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-input__slot {
  margin-bottom: 0 !important;
}
.v-text-field__details {
  padding-top: 8px;
  min-height: unset;
}
.v-application .rounded-b-xl {
  border-radius: 0 !important;
}
@media only screen and (max-width: 600px) {
  form {
    width: unset !important;
  }
}
#card-element {
  border-radius: 6px;
}
.vue-html2pdf .content-wrapper {
  margin-left: 0 !important;
}
@media (max-width: 991px) {
  .content-wrapper {
    width: 100% !important;
  }
}
.pdf-content {
  margin: 0px !important;
  padding: 0px !important;
}

.v-data-table__wrapper::-webkit-scrollbar {
  height: 6px !important;
  background-color: #f5f5f5;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.row {
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
.v-application--is-ltr .v-list.v-sheet--shaped {
  padding: 0 !important;
  border-radius: none;
}
/* td{
    padding: 10px!important;
} */
.v-pagination__item--active {
  box-shadow: unset;
}
.v-pagination__item {
  box-shadow: unset;
}
.v-pagination__navigation {
  box-shadow: unset;
}
.v-btn__content,
.sidebar .nav .nav-item .nav-link,
h2,
h3,
h4,
h5,
h6,
.accordion,
.alert,
.badge,
.breadcrumb,
.btn,
.dropdown,
.form-control,
.tt-hint,
.tt-query,
.typeahead,
.nav,
.pagination,
.progress,
a,
p {
  font-family: "Nunito", sans-serif !important;
}
.card-details {
  background: #fff;
}
.v-menu__content,
.v-dialog {
  box-shadow: 0px 4px 12px rgb(39 48 57 / 5%);
}
.v-list {
  padding: 0;
}
.text-h6 {
  font-family: "Nunito", sans-serif !important;
}
.v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  font-weight: bold;
}
.loader-spinner {
  width: 50px !important;
  height: 50px !important;
}
.v-input--radio-group.v-input--radio-group--row .v-radio {
  background: #fff;
  padding: 10px;
  border-radius: 6px;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 12px !important;
}
.v-list-item {
  min-height: 38px !important;
}
.v-list-item__icon {
  margin: 8px 0 !important;
}
.v-data-table header {
  height: 2px;
}
.bg-white {
  background-color: #fff;
}
.add_btn {
  cursor: pointer;
  border: 1px dashed gray;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: gray;
}
.add_btn:hover {
  background-color: rgb(237, 234, 234);
  color: black;
  transition-duration: 700ms;
}
</style>
